import React from 'react';
import {Box} from "@material-ui/core";
import PropTypes from "prop-types";

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
}

export default function TabPanel(props) {

    const {children, value, index, ...other} = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}>
            {value === index && (
                <Box style={{p: 3}}>
                    <div>
                        {children}
                    </div>
                </Box>
            )}
        </div>
    )
}